/**
 * Поле даты. У `TextInput` Gravity нет типа `date`, а календарь
 * `@gravity-ui/date-components` тянет ещё одну библиотеку дат ради выбора дня:
 * родное поле браузера с рамкой и фокусом из тех же токенов делает то же —
 * календарь, ввод с клавиатуры и формат дня по системе.
 */
export function DateInput({
  id,
  value,
  onUpdate,
  label,
  size = 'm',
  invalid = false,
  ariaLabel,
}: {
  id?: string;
  value: string;
  onUpdate: (value: string) => void;
  /** Короткая подпись внутри рамки, как у `label` в `TextInput`: «С», «По». */
  label?: string;
  size?: 'm' | 'l';
  invalid?: boolean;
  ariaLabel?: string;
}) {
  return (
    <label className={`odx-date odx-date_size_${size} ${invalid ? 'odx-date_invalid' : ''}`}>
      {label === undefined ? null : <span className="odx-date__label">{label}</span>}
      <input
        id={id}
        type="date"
        className="odx-date__control"
        value={value}
        aria-label={ariaLabel ?? label}
        aria-invalid={invalid || undefined}
        onChange={(event) => {
          onUpdate(event.target.value);
        }}
      />
    </label>
  );
}
